import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "matrix-scale mt-20"
  }, [_c('div', {
    staticClass: "option-title"
  }, [_c('div', {
    staticClass: "question-title"
  }), _vm.children[0].options ? _c('div', {
    staticClass: "matrix-scale-option-item"
  }, _vm._l(_vm.children[0].options, function (option) {
    return _c('div', {
      key: option.option_id,
      staticClass: "ant-radio-wrapper"
    }, [_vm._v(_vm._s(option.title))]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "option-title orange"
  }, [_c('div', {
    staticClass: "question-title"
  }, [_vm._v(_vm._s(_vm.t('分值')))]), _vm.children[0].options ? _c('div', {
    staticClass: "matrix-scale-option-item"
  }, _vm._l(_vm.children[0].options, function (option) {
    return _c('div', {
      key: option.option_id,
      staticClass: "ant-radio-wrapper orange"
    }, [_vm._v(_vm._s(option.value))]);
  }), 0) : _vm._e()]), _c('div', {
    staticClass: "matrix-scale-value"
  }, _vm._l(_vm.children, function (item, index) {
    return _c('div', {
      key: item.question_id,
      staticClass: "question-item"
    }, [_c('span', {
      staticClass: "question-title"
    }, [_vm._v(_vm._s(item.title))]), item.options ? _c('a-radio-group', {
      on: {
        "change": _vm.handleChange
      },
      model: {
        value: _vm.value[index].option_id,
        callback: function ($$v) {
          _vm.$set(_vm.value[index], "option_id", $$v);
        },
        expression: "value[index].option_id"
      }
    }, _vm._l(item.options, function (option) {
      return _c('a-radio', {
        key: option.option_id,
        attrs: {
          "value": option.option_id
        }
      });
    }), 1) : _vm._e()], 1);
  }), 0)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };